import HomePage from './pages/home'

export default HomePage
